import styled from "styled-components";

// import colors from '../../constants/colors'
import breakpoints from "../../constants/breakpoints";
// import fonts from '../../constants/fonts'

export const Wrap = styled.div`
  width: 100%vw;
  display: flex;
  flex-direction: row;
  height: 100vh;
  max-height: calc(100vh - 90px);
  @media screen and (max-width: ${breakpoints.ipad.pixels}) {
    flex-direction: column;
  }

  & > div:first-of-type {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 65%;
    background-image: url(${require("./cover.png")});
    background-position: center;
    background-repeat: no-repeat;
    object-fit: cover;
    background-size: cover;
    padding: 0 0 0 4%;
    @media screen and (max-width: ${breakpoints.desktop.pixels}) {
      width: 40%;
    }
    @media screen and (max-width: ${breakpoints.ipad.pixels}) {
      width: 100%;
    }
    & > h2 {
      font-size: 35px;
      line-height: 36px;
      color: white;
      font-weight: 600;
    }
  }

  & > div:last-of-type {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 35%;
    @media screen and (max-width: ${breakpoints.desktop.pixels}) {
      width: 60%;
    }
    @media screen and (max-width: ${breakpoints.ipad.pixels}) {
      width: 100%;
    }
  }
`;

export const FormWrapper = styled.section`
  display: flex;
  flex-direction: column;
  padding: 32px 15%;
  width: 100%;
  overflow-y: scroll;
  & > div {
    & > h3 {
      font-size: 18px;
      line-height: 22px;
      font-weight: 400;
    }
    & > div {
      display: flex;
      flex-direction: row;
      width: 100%;
      margin: 16px 0;
      justify-content: space-between;
      @media screen and (max-width: 600px) {
        flex-direction: column;
      }
    }
    & > a {
      width: 100%;
      text-align: center;
      outline: none;
      color: #4d4d4d;
      font-size: 12px;
    }
  }
`;

export const CustomInput = styled.input`
  outline: none;
  border-top: 1px solid gray;
  border-left: 1px solid gray;
  border-right: 1px solid gray;
  border-bottom: 1px solid gray;
  width: 100%;
  height: 32px;
  margin: 8px 0 0 0;
`;

export const Label = styled.label`
  display: flex;
  margin: 16px 0;
  flex-direction: column;
  width: 100%;
  font-weight: 600;
  & > div {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    & > span {
      font-size: 12px;
      color: grey;
      font-weight: 600;
    }
  }
`;

export const SubmitBtn = styled.input`
  width: ${(props) => (props.formType === "register" ? "100%" : "40%")};
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 2px;
  background-color: #e8c468;
  color: white;
  font-size: 15px;
  outline: none;
  border: none;
  &:hover {
    background-color: rgba(232, 196, 104, 0.8);
  }
`;

export const ButtonSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: ${(props) => (props.formType === "register" ? "column" : "row")};
  justify-content: space-around;
  align-items: center;
  margin: 16px 0;
  & > a {
    outline: none;
    color: #4d4d4d;
    font-size: 12px;
    @media screen and (max-width: 600px) {
      margin: 16px 0 0 0;
    }
  }
`;

export const Messages = styled.span`
  display: flex;
  height: 32px;
  color: ${(props) => props.color};
  margin: 8px 0;
`;

export const Space = styled.span`
  width: 32px;
`;

export const CustomSelect = styled.select`
  outline: none;
  border-top: 1px solid gray;
  border-left: 1px solid gray;
  border-right: 1px solid gray;
  border-bottom: 1px solid gray;
  width: 100%;
  height: 32px;
  margin: 8px 0 0 0;
`;

export const Privacy = styled.section`
  display: flex;
  flex-direction: row;
  & > label {
    display: flex;
    flex-direction: row;
    margin: 0 0 0 8px;
    & > a {
      outline: none;
      color: #4d4d4d;
      margin: 0 0 0 4px;
    }
  }
`;
